import React from 'react';
import styled from 'styled-components';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import GridLayout, { Layout as LayoutProp } from 'react-grid-layout';
import _ from 'lodash';

import NumberRowFontSizeProvider from 'components/Studio/NumberRowFontSizeContext';

import ReportCanvasCard from '../ReportCanvasCard';
import { LayoutTier } from './buildLayout';
import RenderWhenInView from '../Comments/RenderWhenInView';
import ChartColorsProvider from '../../contextProviders/ChartColorsProvider';
import {
  CANVAS_ITEM_MARGIN,
  CANVAS_PADDING_HORIZONTAL,
  CANVAS_PADDING_VERTICAL,
} from './canvasConstants';
import { Z_INDEX } from '../../constants';
const Wrapper = styled.div`
  .react-grid-item.react-grid-placeholder {
    background: var(--color-navy) !important;
  }
  .react-grid-item {
    z-index: 1;
  }
  .react-resizable-handle {
    z-index: ${Z_INDEX.CANVAS_CARD_RESIZE_HANDLE};
  }
`;

const ReportCanvas = ({
  cards,
  layout,
  onLayoutChange,
  removeGadget,
  isEditing,
  cardOnTopI,
  tier,
  onResizeStart,
  onResizeStop,
  draggingI,
  canvasRowHeight,
  canvasWidth,
}: {
  cards: CanvasCard.Card[];
  layout: GridLayout.Layout[];
  onLayoutChange: (newLayout: GridLayout.Layout[]) => void;
  removeGadget: (i: string) => void;
  isEditing: boolean;
  cardOnTopI?: string;
  tier: LayoutTier;
  onResizeStart: (
    layout: LayoutProp,
    oldItem: any,
    newItem: any,
    placeholder: any,
    e: MouseEvent,
    element: HTMLElement,
  ) => void;
  onResizeStop: () => void;
  draggingI?: string;
  canvasRowHeight: number;
  canvasWidth: number;
}) => {
  // Cards are sized by the displayed (possibly reflowed) layout, not their
  // authored one.
  const layoutLookup = _.keyBy(layout, 'i');

  return (
    <div>
      <ChartColorsProvider>
        <NumberRowFontSizeProvider shownLayout={layout}>
          <Wrapper>
            <GridLayout
              width={canvasWidth}
              key={tier}
              className="layout"
              layout={layout}
              cols={12}
              margin={[CANVAS_ITEM_MARGIN, CANVAS_ITEM_MARGIN]}
              containerPadding={[
                CANVAS_PADDING_HORIZONTAL,
                CANVAS_PADDING_VERTICAL,
              ]}
              rowHeight={canvasRowHeight}
              draggableHandle=".draggableHandle"
              onLayoutChange={onLayoutChange}
              useCSSTransforms={false}
              // @ts-ignore
              onResizeStart={onResizeStart}
              onResizeStop={onResizeStop}
            >
              {cards.map((c) => {
                const { i } = c.layout;
                const { w, h } = layoutLookup[i] ?? c.layout;
                return (
                  <div
                    style={{
                      zIndex: i === cardOnTopI ? 1 : 0,
                      width: '100%',
                      height: '100%',
                    }}
                    key={`${i}`}
                  >
                    <div
                      style={{
                        width: '100%',
                        height: '100%',
                      }}
                      key={`${w}-${h}`}
                    >
                      <RenderWhenInView>
                        <ReportCanvasCard
                          card={c}
                          w={w}
                          h={h}
                          onRemoveClicked={() => removeGadget(i)}
                          isEditing={isEditing}
                          isDragging={!!draggingI && draggingI === i}
                        />
                      </RenderWhenInView>
                    </div>
                  </div>
                );
              })}
            </GridLayout>
          </Wrapper>
        </NumberRowFontSizeProvider>
      </ChartColorsProvider>
    </div>
  );
};

export default ReportCanvas;
